export const getRedirectForRegistration = (isRegistered: boolean, hasEmail: boolean): string => {
  if (isRegistered) return '/main';
  if (!hasEmail) return '/without-email';

  return localStorage.getItem('operatorType') === 'operator' ? '/registration-of-operator' : '/registration';
};
